import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { setScreenType } from '../../../store/slices/dialSlice';
import * as Icon from 'react-feather';
import { transferUserOptionGet, userCall } from '../../../store/slices/callingSlice';
import FormSelect from '../../form/FormSelect';
import { useTranslation } from 'react-i18next';

// User-to-user (agent-to-agent) internal call. Reached from the dial pad's
// "Call Agent" button. Lists company agents and originates via /call_originate/user_call.
const UserCallScreen = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [userOptions, setUserOptions] = useState([]);
  const [targetUserId, setTargetUserId] = useState('');

  const fetchUserOptions = async () => {
    try {
      const response = await dispatch(transferUserOptionGet()).unwrap();
      if (response && response.success) {
        const options = (response?.data || []).map((item) => ({
          // Username with agent name in brackets; searchable by agent name.
          label: item.agent_name ? `${item.Username} (${item.agent_name})` : item.Username,
          value: item.id
        }));
        setUserOptions(options || []);
      } else {
        setUserOptions([]);
      }
    } catch (error) {
      setUserOptions([]);
      console.error('Error fetching agent options:', error);
    }
  };

  useEffect(() => {
    fetchUserOptions();
  }, []);

  const placeCall = async () => {
    try {
      await dispatch(userCall({ target_user_id: targetUserId })).unwrap();
      dispatch(setScreenType('LIVE_CALL'));
    } catch (error) {
      console.log('user_call error', error);
    }
  };

  useEffect(() => {
    if (targetUserId) {
      placeCall();
    }
  }, [targetUserId]);

  return (
    <div className="h-100 call-action-btn-container">
      <div className="mt-auto mb-3 text-white text-center fw-bold fs-5">
        {t('callAgent') !== 'callAgent' ? t('callAgent') : 'Call Agent'}
      </div>
      <div className="text-white mb-auto">
        <FormSelect
          isShowLabel={false}
          name="targetUserId"
          label={t('user')}
          placeholder="Select Agent"
          value={targetUserId}
          options={userOptions}
          onChange={(e) => {
            setTargetUserId(e?.target?.value);
          }}
        />
      </div>
      <div className="call-button-wrapper mt-auto pb-4">
        <Button
          className="back-button"
          onClick={() => {
            dispatch(setScreenType(null));
          }}>
          <Icon.ArrowLeft className="back-icon text-primary" />
        </Button>
      </div>
    </div>
  );
};

export default UserCallScreen;
